export default __webpack_public_path__ + "static/media/aisIcon.07faffe4.png";